import { motion } from 'framer-motion';
import { Target, Disc, ArrowDown, TreePine, Mountain, Layers, Repeat, Flag } from 'lucide-react';

const disciplines = [
  { name: 'Skeet Olympique', desc: 'Analyse Pull/Mark détaillée', icon: Target },
  { name: 'Trap', desc: 'Suivi par trajectoire : droite, milieu, gauche', icon: Disc },
  { name: 'DTL', desc: 'Down The Line', icon: ArrowDown },
  { name: 'Compak Sporting', desc: 'Analyse complète', icon: Layers },
  { name: 'Parcours de Chasse', desc: 'Parcours variés', icon: TreePine },
  { name: 'Fosse Universelle', desc: 'Fosse standard', icon: Mountain },
  { name: 'Double Trap', desc: 'Deux plateaux simultanés', icon: Repeat },
  { name: 'Ball-Trap Américain', desc: 'Style américain', icon: Flag },
];

export default function Disciplines() {
  return (
    <section id="disciplines" data-testid="disciplines-section" className="py-24 sm:py-32 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-[#FF6B35] text-sm font-semibold uppercase tracking-widest font-['Poppins']"
          >
            Disciplines
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-white font-['Poppins'] font-bold text-3xl sm:text-4xl mt-3"
          >
            8 disciplines supportées
          </motion.h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {disciplines.map((d, i) => {
            const Icon = d.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.06, duration: 0.4 }}
                data-testid={`discipline-${i}`}
                className="group relative bg-[#1A1A1A] rounded-2xl p-5 border border-white/5 hover:border-[#FF6B35]/30 transition-all duration-300 hover:-translate-y-1 overflow-hidden"
              >
                <div className="absolute top-0 right-0 w-20 h-20 bg-[#FF6B35]/5 rounded-full -translate-x-4 -translate-y-4 group-hover:bg-[#FF6B35]/10 transition-colors duration-300" />
                <Icon size={28} className="text-[#FF6B35] mb-3 relative z-10" />
                <h3 className="text-white font-['Poppins'] font-semibold text-sm sm:text-base mb-1 relative z-10">{d.name}</h3>
                <p className="text-[#A0A0A0] text-xs relative z-10">{d.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
